import { create, v } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/framework/core/middleware/theme';

// make generated .d.ts file valid
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { WNodeFactory, WidgetProperties, DNode } from '@dojo/framework/core/interfaces';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { I18nProperties, DefaultChildrenWNodeFactory } from '@dojo/framework/core/interfaces';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ThemeProperties } from '@dojo/framework/core/middleware/theme';

import css from '../css/resource-parser.m.css';

const factory = create({ theme });

export const Heading1 = factory(({ properties, children, middleware: { theme } }) => {
	const { key } = properties();
	const themeCss = theme.classes(css);

	return v('h1', { key, classes: [themeCss.head1] }, children());
});

export const Heading2 = factory(({ properties, children, middleware: { theme } }) => {
	const { key } = properties();
	const themeCss = theme.classes(css);

	return v('h2', { key, classes: [themeCss.head2] }, children());
});

export const Heading3 = factory(({ properties, children, middleware: { theme } }) => {
	const { key } = properties();
	const themeCss = theme.classes(css);

	return v('h3', { key, classes: [themeCss.head3] }, children());
});
